import React, { useState } from "react";
import { Slide, Zoom } from "react-awesome-reveal";
import {
  Gear,
  Award,
  People,
  ClockHistory,
  ExclamationTriangle,
  Trash,
} from "react-bootstrap-icons";
import "../../styles/EcosistemaSection.css";

const indicators = [
  {
    name: "OEE",
    icon: <Gear size={28} />,
    full: "Overall Equipment Effectiveness",
    desc: "Mide la eficiencia global de tus equipos combinando disponibilidad, rendimiento y calidad. Twinexa lo calcula automáticamente en tiempo real.",
  },
  {
    name: "FTQ",
    icon: <Award size={28} />,
    full: "First Time Quality",
    desc: "Porcentaje de piezas producidas correctamente a la primera. Con MES, cada defecto queda trazado y el índice se actualiza al instante.",
  },
  {
    name: "DLE",
    icon: <People size={28} />,
    full: "Direct Labour Efficiency",
    desc: "Eficiencia real del trabajo directo vs. el tiempo estándar planificado. Identificá brechas de productividad sin depender de planillas.",
  },
  {
    name: "MTBF",
    icon: <ClockHistory size={28} />,
    full: "Mean Time Between Failures",
    desc: "Tiempo promedio entre fallas de un equipo. Twinexa registra cada paro y calcula el MTBF para orientar el mantenimiento preventivo.",
  },
  {
    name: "Scrap Rate",
    icon: <Trash size={28} />,
    full: "Tasa de Desperdicio",
    desc: "Proporción de material descartado respecto al total producido. Automatizamos su registro y te mostramos las causas raíz en segundos.",
  },
  {
    name: "Downtime",
    icon: <ExclamationTriangle size={28} />,
    full: "Tiempo de Paro",
    desc: "Tiempo en que una línea o máquina no produce. El sistema categoriza cada paro automáticamente para que actúes antes de que el impacto escale.",
  },
];

const IndicatorCard = ({ ind, index }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <Zoom delay={150 + index * 100} duration={600} triggerOnce>
      <div
        className={`eco-indicator-card${flipped ? " flipped" : ""}`}
        onClick={() => setFlipped((f) => !f)}
      >
        {/* Front */}
        <div className="eco-ind-front">
          <div className="eco-ind-icon">{ind.icon}</div>
          <h3 className="eco-ind-name">{ind.name}</h3>
          <p className="eco-ind-full">{ind.full}</p>
          <span className="eco-ind-hint">Ver más →</span>
        </div>

        {/* Back */}
        <div className="eco-ind-back">
          <h3 className="eco-ind-name">{ind.name}</h3>
          <p className="eco-ind-desc">{ind.desc}</p>
          <span className="eco-ind-hint">← Volver</span>
        </div>
      </div>
    </Zoom>
  );
};

const IndicatorsSection = () => (
  <section className="eco-section" id="indicadores">
    <div className="container py-5">
      <Slide direction="up" duration={700} triggerOnce>
        <div className="text-center mb-5">
          <span className="eco-badge">Industria 4.0</span>
          <h2 className="eco-main-title text-white mt-3">
            Indicadores que Twinexa automatiza
          </h2>
          <p className="eco-main-sub text-white-50">
            Hacé clic en cada tarjeta para conocer cómo los medimos y
            actualizamos en tiempo real.
          </p>
        </div>
      </Slide>

      <div className="eco-indicators-grid">
        {indicators.map((ind, i) => (
          <IndicatorCard key={ind.name} ind={ind} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default IndicatorsSection;
